import { useContext } from 'react';
import PaymentContext from 'App/helpers/payment/PaymentContext';

export const usePayment = () => {
  return useContext(PaymentContext);
};
